import { Section } from "@/app/lib/features/home/home.types";

/**
 * HomeSectionLoader'a ulaşan Section nesneleri için geçerlidir.
 * "story" ve "collection" display_type'ları HomeSectionLoader'da
 * type guard'larla daha önce ele alınır; buraya ulaşmaz.
 *
 * Bu fonksiyon SectionRenderer'a yönlendirilmeden önce son filtre
 * olarak kullanılır: hero, categories, brands, instagram ve
 * manual-grid display_type'ları kendi özel component'lerine zaten
 * yönlendirilmiştir, dolayısıyla SectionRenderer bunları atlamalıdır.
 */
export const shouldSkipSection = (section: Section): boolean => {
  if (section.display_type === "slider") return true;
  if (section.display_type === "hero") return true;
  if (section.display_type === "categories") return true;
  if (section.display_type === "brands") return true;
  if (section.display_type === "instagram") return true;
  if (section.display_type === "grid" && section.content_source === "manual") return true;
  return false;
};
